import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  computed,
  inject,
  signal,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { SplitButtonModule } from 'primeng/splitbutton';

import { BackIcon } from '@components/back-icon/back-icon.component';
import { CustomBreadcrumbsComponent } from '@components/custom-breadcrums/custom-breadcrums.component';
import { MainDrawerComponent } from '@layouts/dashboard/components/main/main-drawer/main-drawer.component';
import { SecondaryDrawerComponent } from '@layouts/dashboard/components/main/secondary-drawer/secondary-drawer.component';

import {
  InjectAttributeDirective,
  InjectAttributeModel,
} from '@directives/inject-attribute.directive';

import { UserStore } from '@cxc/core/services';
import { RouterState } from '@cxc/core/services';
import { DashboardState } from '@services/state/dashboard.state';
import { OperationsState } from '@services/state/operation-state/operation.state';

@Component({
  selector: 'dashboard-main',
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    SplitButtonModule,
    BreadcrumbModule,
    BackIcon,
    MainDrawerComponent,
    SecondaryDrawerComponent,
    CustomBreadcrumbsComponent,
    InjectAttributeDirective,
  ],

  animations: [
    trigger('expandColapseActionTitle', [
      state('true', style({ height: '36px', minHeight: '36px', opacity: 1 })),
      state('false', style({ height: '0px', minHeight: '0px', opacity: 0 })),
      transition('* => *', animate('0.25s ease-out')),
    ]),
  ],
})
export class DashboardMainComponentt {
  activeRoute = signal('operations');

  public dashboardState = inject(DashboardState);
  public operationsState = inject(OperationsState);
  public routerState = inject(RouterState);

  private router = inject(Router);
  private userStore = inject(UserStore);

  analyticsForBreadcrumbs = computed<InjectAttributeModel[]>(() => {
    const urlFragments = this.routerState.urlFragments();

    return this.routerState.breadcrumbs().map((breadcrumb, i) => {
      const attribute: InjectAttributeModel = {
        CSSPath: `.p-breadcrumb-item:nth-child(${i + 1} of .p-breadcrumb-item) > a`,
        attribute: 'analytics-label',
        value: `${urlFragments[1]}/${urlFragments[2]}/breadcrumb/crumb-${i + 1}`,
      };

      return attribute;
    });
  });

  constructor() {}

  clickAction(route: string) {
    if (route === this.activeRoute()) {
      this.dashboardState.mainDrawer.toggle();
      return;
    }

    this.router.navigateByUrl(route);
  }
}
